module.exports = __webpack_public_path__ + "static/default-cover-ae87518ebc1bba20055ee5923073b7ac.png";